import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from "antd";
import { ColumnType } from "antd/lib/table";
import moment from "moment";
import { PauseHistoryItem } from "../../../../types/model/subscriptions";
import { fetchPauseHistory } from "../../../../services/subscription";
import { EMPTY } from "../../../../constants/common";
import { EComModal } from "../../../../components/EComModal";

const DATE_FORMAT = "YYYY-MM-DD";

interface Props {
  subscriptionId: string | null;
  visible: boolean;
  closeModal: () => void;
}

const columns: ColumnType<PauseHistoryItem>[] = [
  {
    title: "Status",
    dataIndex: "status",
    width: 140,
  },
  {
    title: "Created at",
    dataIndex: "createdAt",
    width: 120,
    render: (value: string) => moment(value).format(DATE_FORMAT),
  },
  {
    title: "Paused from",
    dataIndex: "pausedFrom",
    width: 120,
    render: (value: string) => moment(value).format(DATE_FORMAT),
  },
  {
    title: "Pause until",
    dataIndex: "pauseUntil",
    width: 120,
    render: (value: string) => moment(value).format(DATE_FORMAT),
  },
  {
    title: "Resumed at",
    dataIndex: "resumedAt",
    width: 120,
    render: (value: string | null) => (value ? moment(value).format(DATE_FORMAT) : EMPTY),
  },
  {
    title: "Paused by",
    dataIndex: "createdBy",
    width: 140,
    render: (value: string | null) => value ?? EMPTY,
  },
  {
    title: "Resumed by",
    dataIndex: "resumedBy",
    width: 140,
    render: (value: string | null) => value ?? EMPTY,
  },
];

export default function PauseHistoryModal({ subscriptionId, visible, closeModal }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const [history, setHistory] = useState<PauseHistoryItem[]>([]);

  useEffect(() => {
    if (!visible || !subscriptionId) return;
    setIsLoading(true);
    fetchPauseHistory(subscriptionId)
      .then((data) => setHistory(data))
      .finally(() => setIsLoading(false));
  }, [visible, subscriptionId]);

  return (
    <EComModal title="Subscription Pause History" visible={visible} width={1100} onCancel={closeModal} footer={null}>
      <Table<PauseHistoryItem>
        loading={isLoading}
        columns={columns}
        dataSource={history}
        rowKey={(_, index) => String(index)}
        scroll={{ x: "max-content" }}
        pagination={false}
      />
    </EComModal>
  );
}
